import cn from 'classnames';
import { CoordinateIcon } from './icons/CoordinateIcon';
import { Coordinate } from '@widgets/create-warehouse/map';
import {
  CreateWarehouseStep,
  ICreateWarehouseStepProps,
} from '@@/warehouses/components/create-warehouse-step';

import styles from './styles.module.css';

export const WarehouseCoordinates = (props: IWarehouseCoordinatesProps) => {
  const { className, marker, hasIntersection, ...rest } = props;
  const rootClass = cn(styles.root, className);

  return (
    <CreateWarehouseStep
      className={rootClass}
      next={{ label: 'Сохранить склад', disabled: !marker || hasIntersection }}
      {...rest}
    >
      <span className={styles.title}>Координаты склада:</span>

      <div className={styles.coordinatesWrapper}>
        <CoordinateIcon />
        <div className={styles.coordinates}>
          <span>{marker ? Math.round(marker[0] * 1000000) / 1000000 : ''},</span>
          <span>{marker ? Math.round(marker[1] * 1000000) / 1000000 : ''}</span>
        </div>
      </div>

      {hasIntersection && <div className={styles.msg}>Склады пересекаются</div>}
    </CreateWarehouseStep>
  );
};

export interface IWarehouseCoordinatesProps extends ICreateWarehouseStepProps {
  marker?: Coordinate;
  hasIntersection?: boolean;
}
